import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';
import formatarData from '~js/formatar-data';

Vue.use(VueResource);

async function normalizarParaVisualizar(solicitacao) {
  solicitacao.itensSolicitacaoImportacao.map(item => {
    item.quantidade = converterMoeda.paraReal(item.quantidade);
    item.valorEstimado = converterMoeda.paraReal(item.valorEstimado);
    item.desconto = converterMoeda.paraReal(item.desconto);
    item.vat = converterMoeda.paraReal(item.vat);
  });

  if (solicitacao.dataAprovacao) {
    solicitacao.dataAprovacao = await formatarData.paraData(solicitacao.dataAprovacao);
  }
  else
    solicitacao.dataAprovacao = '';

  if (solicitacao.dataProforma) {
    solicitacao.dataProforma = await formatarData.paraData(solicitacao.dataProforma);
  }
  else
    solicitacao.dataProforma = '';

  if (solicitacao.dataNR) {
    solicitacao.dataNR = await formatarData.paraData(solicitacao.dataNR);
  }
  else
    solicitacao.dataNR = '';

  return solicitacao;
}

async function normalizarParaSalvar(solicitacao) {
  if (solicitacao.dataAprovacao) {
    solicitacao.dataAprovacao = await formatarData.paraNumero(solicitacao.dataAprovacao);
  }

  if (solicitacao.dataProforma) {
    solicitacao.dataProforma = await formatarData.paraNumero(solicitacao.dataProforma);
  }

  if (solicitacao.dataNR) {
    solicitacao.dataNR = await formatarData.paraNumero(solicitacao.dataNR);
  }

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaoimportacao', { params: parametros });
  },
  adicionar: async (solicitacao, arquivos) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaoimportacao', solicitacao).then(res => res.data.id);
  },
  alterar: async (solicitacao, arquivos, id) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.put(`/api/solicitacaoimportacao/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: async id => {
    return Vue.http.get(`/api/solicitacaoimportacao/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaoimportacao/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaoimportacao/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  listaBancos: function () {
    return Vue.http.get('/api/solicitacaoimportacao/bancos').then(response => response.data);
  },
  listaMoedas: function () {
    return Vue.http.get('/api/solicitacaoimportacao/moedas').then(response => response.data);
  },
  listaFormaPagamentos: function () {
    return Vue.http.get('/api/solicitacaoimportacao/formapagamentos').then(response => response.data);
  },
  listaIncoterm: function () {
    return Vue.http.get('/api/solicitacaoimportacao/incoterm').then(response => response.data);
  },
  listaPrevisaoEntregas: function () {
    return Vue.http.get('/api/solicitacaoimportacao/previsaoentregas').then(response => response.data);
  },
  listaTipoEmbarque: function () {
    return Vue.http.get('/api/solicitacaoimportacao/tiposembarque').then(response => response.data);
  },
  listaDestinoCarga: function () {
    return Vue.http.get('/api/solicitacaoimportacao/destinoscarga').then(response => response.data);
  },
  listaAgencias: function (idBanco) {
    return Vue.http.get(`/api/solicitacaoimportacao/${idBanco}/agencias`).then(response => response.data);
  },
  listaContas: function (idAgencia) {
    return Vue.http.get(`/api/solicitacaoimportacao/${idAgencia}/contas`).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-importacao/servico.js